import { createSlice } from "@reduxjs/toolkit";
import i18n from "./../../../i18n";
import { constant } from "../../../config/constant";
// import { useLocation } from "react-router-dom";
// import { useTranslation } from "react-i18next";
const initialState = {
  logoutDetails: {},
  crmLogoutData: {},
  isLoading: false,
  error: false,
  codeStatus: "pending",
  navigateRop: false,
  sessionExp: false
};
const isDapiPath = () => {
  return constant?.dapiPaths?.some(item => location.pathname?.includes(item));
};
const logoutSession = () => {
  Object.keys(sessionStorage).filter(key => key !== "persist:dapibooking").forEach(key => sessionStorage.removeItem(key));
};
function handleLogoutState(logoutDetails, codeStatus, navigate) {
  if (codeStatus === "success") {
    if (logoutDetails.code === "200" || logoutDetails?.success) {
      if (navigate) {
        logoutSession();
        localStorage?.removeItem("accesstoken");
        localStorage?.removeItem("isROPLoggedIn");
        localStorage?.removeItem("isCRMLoggedIn");
        sessionStorage.setItem("navigateRop", "true");
        window.location.reload();
      } else {
        logoutSession();
        localStorage?.removeItem("accesstoken");
        localStorage?.removeItem("isROPLoggedIn");
        localStorage?.removeItem("isCRMLoggedIn");
        window.location.reload();
      }
    }
  } else if (codeStatus === "failure") {
    logoutSession();
    localStorage?.removeItem("accesstoken");
    localStorage?.removeItem("isROPLoggedIn");
    localStorage?.removeItem("isCRMLoggedIn");
    window.location.reload();
  }
}
const LogOutSlice = createSlice({
  name: "logout",
  initialState,
  reducers: {
    logoutRequest: state => {
      state.isLoading = true;
      state.error = null;
      state.codeStatus = "pending";
      state.sessionExp = true;
    },
    getLogOutSuccess: (state, action) => {
      state.logoutDetails = action.payload;
      state.isLoading = false;
      state.codeStatus = "success";
      handleLogoutState(action.payload, "success", state.navigateRop);
      if (!isDapiPath()) {
        window.location.href = window.location.origin + "/" + i18n?.language;
      }
    },
    getLogOutFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.codeStatus = "failure";
      handleLogoutState(action.payload, "failure");
    },
    crmLogoutRequest: state => {
      state.isLoading = true;
      state.error = null;
      state.codeStatus = "pending";
    },
    crmGetLogOutSuccess: (state, action) => {
      state.crmLogoutData = action.payload;
      state.isLoading = false;
      state.codeStatus = "success";
      handleLogoutState(action.payload, "success");
    },
    crmGetLogOutFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.codeStatus = "failure";
      handleLogoutState(action.payload, "failure");
    },
    setNavigateRop: (state, action) => {
      state.navigateRop = action.payload;
    },
    logoutRequestSession: state => {
      state.isLoading = true;
      state.error = null;
      state.codeStatus = "pending";
      state.sessionExp = true;
    },
    setSessionExp: state => {
      state.sessionExp = false;
    }
  }
});
export const {
  logoutRequest,
  getLogOutSuccess,
  getLogOutFailure,
  crmLogoutRequest,
  crmGetLogOutSuccess,
  crmGetLogOutFailure,
  setNavigateRop,
  logoutRequestSession,
  setSessionExp
} = LogOutSlice.actions;
export default LogOutSlice.reducer;